export default __webpack_public_path__ + "static/media/gallery.fa093e60.png";